module.exports = __webpack_public_path__ + "static/media/blackClose.12321b6b.svg";